<template>
    <div class="data-container">
        <div class="tool-box">
            <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
            <el-button type="primary" :icon="Plus" plain @click="onAddClick()" v-permission="['school:plus']">添加</el-button>
            <el-button type="primary" :icon="Download" plain @click="importsVisible = true" v-permission="['school:import']">
                导入
            </el-button>
        </div>
        <el-form class="search-form" :inline="true" label-position="top" :model="search_data">
            <el-form-item label="单位名称">
                <el-input v-model="search_data.name" clearable placeholder="请输入单位名称" style="width: 150px" />
            </el-form-item>
            <el-form-item label="单位编码">
                <el-input v-model="search_data.code" clearable placeholder="请输入单位编码" style="width: 150px" />
            </el-form-item>
            <el-form-item label="负责人">
                <el-input v-model="search_data.master_name" clearable placeholder="请输入负责人" style="width: 150px" />
            </el-form-item>
            <el-form-item label="联系电话">
                <el-input v-model="search_data.phone" clearable placeholder="请输入联系电话" style="width: 150px" />
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="search_data.status" placeholder="请选择状态" style="width: 165px" clearable>
                    <el-option
                        v-for="item in [
                            { name: '正常', value: 1 },
                            { name: '禁用', value: 0 }
                        ]"
                        :key="item.value"
                        :label="item.name"
                        :value="Number(item.value)"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table class="data-table" :data="table_data">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="code" label="单位编号" min-width="150"></el-table-column>
            <el-table-column prop="name" label="单位名称" min-width="200"></el-table-column>
            <el-table-column prop="master_name" label="负责人"></el-table-column>
            <el-table-column prop="phone" label="联系方式"></el-table-column>
            <el-table-column prop="username" label="管理员账号"></el-table-column>
            <el-table-column prop="status" label="状态" width="150">
                <template #default="{ row }">
                    <el-switch
                        v-model="row.status"
                        :active-value="1"
                        :inactive-value="0"
                        @change="(val) => handleStatus(val, row)"
                        style="--el-switch-on-color: #13ce66"
                    />
                    <span style="margin-left: 15px">{{ row.status == 1 ? '已开启' : '已禁用' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="device_count" label="设备数"></el-table-column>
            <el-table-column label="操作" fixed="right" width="260">
                <template #default="{ row }">
                    <el-button type="primary" v-permission="['school:enter-unit']" :icon="Switch" link @click="enterUnit(row)">
                        进入单位
                    </el-button>
                    <el-button type="primary" v-permission="['school:view']" :icon="View" link @click="onShowClick(row)">
                        详情
                    </el-button>
                    <el-popover placement="bottom">
                        <template #reference>
                            <el-button type="primary" link>
                                更多
                                <el-icon><ArrowRight /></el-icon>
                            </el-button>
                        </template>
                        <template #default>
                            <div class="more-btn-box">
                                <el-button
                                    type="primary"
                                    link
                                    v-permission="['school:edit']"
                                    :icon="Edit"
                                    text
                                    bg
                                    @click="onEditClick(row)"
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    type="primary"
                                    link
                                    v-permission="['school:delete']"
                                    :icon="Delete"
                                    text
                                    bg
                                    @click="onRemoveClick(row)"
                                >
                                    删除
                                </el-button>
                                <el-button
                                    type="primary"
                                    link
                                    v-permission="['school:resetPwd']"
                                    :icon="Refresh"
                                    text
                                    bg
                                    @click="onResetPassword(row)"
                                >
                                    重置密码
                                </el-button>

                                <el-button type="primary" link :icon="Setting" text bg @click="handleSettings(row)">
                                    功能设置
                                </el-button>
                            </div>
                        </template>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="table_data.length > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 50]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
        ></el-pagination>

        <forms-dialog
            v-model="formDialogVisible"
            :isForm="isForm"
            :formId="selectFormId"
            @updateForm="getTableData"
        ></forms-dialog>
        <imports-form v-if="importsVisible" v-model="importsVisible" @updateForm="getTableData" menuCode="school"></imports-form>
        <SettingModule
            v-model="settingVisible"
            @updateForm="getTableData"
            :roleId="selectFormId"
            :checkedAuths="checkedAuths"
            :checkedPartAuths="checkedPartAuths"
        />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import FormsDialog from './components/forms.vue'
import ImportsForm from '@/components/ImportsForm.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { batchOperation } from '@/api/operation'
import { batchDisable, batchEnable, delSchool, getSchoolLists } from '@/api/school.js'
import { Delete, Download, Edit, Plus, Refresh, Search, Setting, Switch, View } from '@element-plus/icons'
import { useStore } from 'vuex'
import SettingModule from './components/SettingModule.vue'

const store = useStore()

// 数据相关
const table_data = ref([{}])
const total = ref(0)
const page = ref(1)
const size = ref(10)
// 获取数据的方法
const search_data = ref({
    name: '',
    code: '',
    master_name: '',
    phone: '',
    address: '',
    status: ''
})
const getTableData = async () => {
    const result = await getSchoolLists({
        page: page.value,
        page_size: size.value,
        ...search_data.value
    })
    table_data.value = result.lists
    total.value = result.total
}

// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') search_data.value[key] = ''
    })
    getTableData()
}

// 分页相关
/**
 * size 改变触发
 */
const handleSizeChange = (currentSize) => {
    size.value = currentSize
    getTableData()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = (currentPage) => {
    page.value = currentPage
    getTableData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectFormId = ref('') // 点中的模块id

// 查看
const onShowClick = (row) => {
    selectFormId.value = row.id
    isForm.value = false
    formDialogVisible.value = true
}
// 编辑
const onEditClick = (row) => {
    selectFormId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    selectFormId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}
// 删除
const onRemoveClick = (row) => {
    ElMessageBox.confirm('是否确认删除' + row.name + '?', {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '删除'
    })
        .then(async () => {
            await delSchool(row.id)
            ElMessage.success('操作成功')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}

// 修改状态
const handleStatus = (val, row) => {
    if (!row.id) return
    const msg = val ? '启用' : '停用'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.name}"吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            if (val) {
                await batchEnable([row.id])
            } else {
                await batchDisable([row.id])
            }
            ElMessage({
                type: 'success',
                message: msg + '成功'
            })
        })
        .catch(() => {
            row.status = val ? 0 : 1
        })
}

// 导入
const importsVisible = ref(false)

// 重置密码
const onResetPassword = (row) => {
    ElMessageBox.prompt('您确定要重置密码吗？', '重置密码', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入新密码，不填则重置为系统预置密码。',
        inputType: 'password',
        inputValidator: (value) => {
            const regex = /^[0-9A-Za-z]{6,24}$/
            if (value === null || value === '') {
                return true
            } else if (!regex.exec(value)) {
                return '密码格式不正确(6-24位数字或字母)'
            } else {
                return true
            }
        }
    })
        .then(async ({ value }) => {
            const res = await batchOperation({ method: 'reset_password', data: [row.admin], password: value })
            if (value) {
                ElMessage({
                    type: 'success',
                    message: '操作成功！'
                })
            } else {
                ElMessage({
                    type: 'success',
                    message: res.msg
                })
            }

            getTableData()
        })
        .catch(() => {})
}

// 功能设置
const settingVisible = ref(false)
const checkedAuths = ref([])
const checkedPartAuths = ref([])
const handleSettings = (row) => {
    selectFormId.value = row.id
    checkedAuths.value = row.auths || []
    checkedPartAuths.value = row.part_auths || []
    settingVisible.value = true
}
// 进入单位
function enterUnit(row) {
    store
        .dispatch('user/switchUser', {
            admin: row.admin
        })
        .then((res) => {
            console.log(res)
        })
}

// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getTableData()
})
</script>

<style scoped></style>
